import { render, staticRenderFns } from "./LiquidationList.vue?vue&type=template&id=655f0aac&scoped=true"
import script from "./LiquidationList.vue?vue&type=script&lang=js"
export * from "./LiquidationList.vue?vue&type=script&lang=js"
import style0 from "./LiquidationList.vue?vue&type=style&index=0&id=655f0aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f0aac",
  null
  
)

export default component.exports